import styles from "./styles.module.scss"
import type { FC, HTMLAttributes } from "react"

interface LogoProps
extends HTMLAttributes<SVGElement> {
  theme?: 'gold' | 'white' | 'slate' | 'navy',

}

export const Logo: FC<LogoProps> = () => (
  <svg className={styles.logo} width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className={styles.triangle}
      vectorEffect="non-scaling-stroke"
      d="M33.6655 67.6654L4.51031 17.1672L62.8206 17.1672L33.6655 67.6654Z" />
    <path className={styles.letter}
      vectorEffect="non-scaling-stroke"
      d="M28 32H29.5859L33.5 38.4049L37.4141 32H39L33.5 41L28 32Z" />
    <path className={styles.triangle}
      vectorEffect="non-scaling-stroke"
      d="M33.6656 67.6655L4.51042 17.1673L62.8207 17.1673L33.6656 67.6655Z" />
  </svg>
)
